import { DEFAULT_TOTEM_ID } from "../../models/totem.ts";
import {
  DEFAULT_WORLD_BALANCE,
  type WorldBalance,
} from "../../models/config/worldBalance.ts";
import {
  WORLD_STATE_SCHEMA_VERSION,
  createEmptyNotificationState,
  createEmptyRandomEventState,
  type TileData,
  type TileKey,
  type WorldState,
} from "../../models/worldState.ts";
import { createRngState } from "../../models/rng/seededRng.ts";

export interface CreateInitialWorldOptions {
  tiles?: Record<TileKey, TileData>;
  balance?: WorldBalance;
}

export function createInitialWorld(
  seed: number,
  options: CreateInitialWorldOptions = {},
): WorldState {
  const balance = options.balance ?? DEFAULT_WORLD_BALANCE;
  return {
    schemaVersion: WORLD_STATE_SCHEMA_VERSION,
    phase: "selectingTotem",
    turn: balance.initialTurn,
    season: "spring",
    clan: {
      clanName: "",
      totemId: DEFAULT_TOTEM_ID,
      population: balance.initialPopulation,
      foodSupplies: balance.initialFoodSupplies,
      currentTile: { q: 0, r: 0 },
      foodBankStreak: 0,
      famineStreak: 0,
      ambientWeather: "clear",
      movedThisTurn: false,
    },
    tiles: options.tiles ?? {},
    rng: createRngState(seed),
    notifications: createEmptyNotificationState(),
    randomEvent: createEmptyRandomEventState(),
  };
}
